<template>
  <df-messenger
    v-if="isAiHelpActive"
    :project-id="projectId"
    :agent-id="agentId"
    language-code="ja"
    max-query-length="-1"
  >
    <df-messenger-chat-bubble
      :bot-actor-image="require(`@/assets/images/iruka-round.png`)"
      chat-title="AIヘルプ"
      anchor="top-right"
      :chat-icon="require(`@/assets/images/iruka-round.png`)"
      placeholder-text="質問を入力してください"
    >
    </df-messenger-chat-bubble>
  </df-messenger>
</template>

<script>
export default {
  name: 'ChatWidget',
  data() {
    return {}
  },
  computed: {
    isAiHelpActive() {
      return this.projectId !== '' && this.agentId !== ''
    },
    projectId() {
      return process.env.VUE_APP_AI_PROJECT_ID || ''
    },
    agentId() {
      return process.env.VUE_APP_AI_AGENT_ID || ''
    },
    // ログインユーザーID
    userId() {
      // ユーザーごとの会話内容を把握
      return this.$store.state.account.userId
    },
    sendQueryParameters() {
      return {
        parameters: {
          user_id: this.userId,
        },
      }
    },
  },
  watch: {},
  methods: {},
  mounted() {
    const waitForMessenger = () => {
      const messenger = document.querySelector('df-messenger')
      const chatBubble = document.querySelector('df-messenger-chat-bubble')
      if (messenger && chatBubble) {
        messenger.addEventListener('df-messenger-loaded', () => {
          // UserIDをセット
          messenger.setQueryParameters(this.sendQueryParameters)
          // 回答はテキストのみとする（ソースのリンクやチップなどを排除）
          messenger.addEventListener('df-response-received', event => {
            const detail = event.detail
            if (!detail || !detail.data || !Array.isArray(detail.data.messages))
              return

            detail.data.messages = detail.data.messages.filter(message => {
              return message.type === 'text'
            })
          })
          // DfMessenger関連の要素上でスクロールしても親画面を動かさないように制御
          chatBubble.addEventListener(
            'wheel',
            e => {
              e.stopPropagation()
            },
            { passive: true },
          )
        })
      } else {
        setTimeout(waitForMessenger, 200)
      }
    }
    waitForMessenger()
  },
}
</script>

<style>
df-messenger {
  z-index: 999;
  position: fixed;
  /* 吹き出しの位置(チャットもここから相対的に位置を決定している。) */
  bottom: 5px;
  left: 16px;
  /* アイコンの位置を左下に */
  --df-messenger-fixed-bottom: 16px;
  --df-messenger-fixed-right: 16px;
  /* アイコンのUI */
  --df-messenger-chat-bubble-icon-size: 65px;
  --df-messenger-chat-bubble-close-icon-size: 30px;
  --df-messenger-chat-bubble-icon-color: #004fe0;
  --df-messenger-message-actor-spacing: 8px;
  --df-messenger-message-actor-padding: 1px; /* 実質アバターの枠線幅 */
  --df-messenger-message-actor-image-size: 40px;
  --df-messenger-message-bot-actor-background: #004fe0;

  /* チャット欄のレイアウト */
  --df-messenger-chat-window-height: 700px;
  --df-messenger-chat-window-width: 400px;
  --df-messenger-chat-padding: 10px;
  --df-messenger-message-border-radius: 8px;
  --df-messenger-input-info-padding: 5px;

  --df-messenger-font-color: #000;
  --df-messenger-font-family: Google Sans;
  --df-messenger-chat-background: #f3f6fc;
  --df-messenger-message-user-background: #d3e3fd;
  --df-messenger-message-bot-background: #fff;
}
df-messenger::part(chat-frame) {
  left: 80px !important;
  bottom: 80px !important;
  right: auto !important;
}
/* チャットのアバター */
df-messenger::part(chat-bot-avatar) {
  border-radius: 50% !important;
  object-fit: cover !important;
  border: none !important;
}
</style>
